import { render, staticRenderFns } from "./CommunicationPassword.vue?vue&type=template&id=7b1bb4c2&scoped=true"
import script from "./CommunicationPassword.vue?vue&type=script&lang=js"
export * from "./CommunicationPassword.vue?vue&type=script&lang=js"
import style0 from "./CommunicationPassword.vue?vue&type=style&index=0&id=7b1bb4c2&prod&lang=scss&scoped=true"
import style1 from "./CommunicationPassword.vue?vue&type=style&index=1&id=7b1bb4c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1bb4c2",
  null
  
)

export default component.exports